import * as Yup from 'yup';
export const locationField = [
  {
    name: 'ats_office_id',
    label: 'Location',
    type: 'asyncSelect',
    labelKey: 'full_address',
    isRequired: true,
    validationType: 'object',
    useInput: true,
    placeholder: `Search city, state or country`,
    updateEndpointOnChange: true,
    fetchConfig: {
      method: 'get',
      endPoint: `/ats_offices/search_location?q=`,
      processResponse: (res) =>
        res?.data?.map((item) => ({
          label: item?.full_address,
          value: item,
          //todo: location office
          ...item,
        })),
    },
    containerStyles: {},
  },
  // note: Be is not supporting the below fields for now
];

export const locationFieldFn = ({ defaultOptions = [] } = {}) => {
  return [
    {
      name: 'ats_office_id',
      label: 'Location',
      type: 'asyncSelect',
      labelKey: 'full_address',
      options: defaultOptions,
      isRequired: true,
      validationType: 'object',
      useInput: true,
      // placeholder: `Search a location`,
      updateEndpointOnChange: true,
      fetchConfig: {
        method: 'get',
        endPoint: `/ats_offices/search_location?q=`,
        processResponse: (res) =>
          res?.data?.map((item) => ({
            label: item?.full_address,
            value: item,
            //todo: location office
            ...item,
          })),
      },
      containerStyles: {},
    },
  ];
};

export const otherLocationFields = [
  {
    name: 'remote',
    label: 'This is remote',
    type: 'checkbox',
    containerStyles: {
      margin: '0',
    },
  },
  {
    name: 'hq',
    label: 'This is HQ',
    type: 'checkbox',
    containerStyles: {
      margin: '0',
    },
  },
  {
    name: 'email',
    label: 'Email',
    type: 'input',
    inputType: 'email',
    optionalValidation: true,
    validation: Yup.string()
      .nullable()
      .email('Valid email address required (if provided)')
      .matches(
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        'Valid email address required (if provided)'
      ),
    validate: (value, item) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const isValidEmail = emailRegex.test(value);

      return !value || item?.isRequired === false
        ? undefined
        : isValidEmail
        ? undefined
        : 'Enter a valid email address';
    },
  },
  {
    name: 'phone',
    label: 'Phone',
    type: 'input',
    inputType: 'tel',
  },
];

export const locationDetailsFields = [
  {
    name: 'country',
    label: 'Country',
    type: 'select',
    containerStyles: {},
    isRequired: true,
    fetchConfig: {
      method: 'get',
      endPoint: `/ats_offices/country_list`,
      processResponse: (res) =>
        res?.data?.sort((a, b) => a.name.localeCompare(b.name)),
    },
    valueKey: 'id',
    labelKey: 'name',
  },
  {
    name: 'state',
    label: 'State',
    type: 'select',
    containerStyles: {},
    disabled: true,
    isRequired: true,
    options: [],
    disabledMessage: 'Please select country first',
    valueKey: 'id',
    labelKey: 'name',
  },
  {
    name: 'city',
    label: 'City',
    type: 'select',
    containerStyles: {},
    isRequired: true,
    disabled: true,
    options: [],
    disabledMessage: 'Please select state first',
    valueKey: 'id',
    labelKey: 'name',
  },
];

export const generateLocationPayload = (
  values = {},
  initialLocationData = null
) => {
  const {
    locationData = {},
    name,
    city,
    state,
    country,
    hq,
    remote,
    ...othersValues
  } = values;

  const {
    latitude,
    longitude,
    location_placeholder,
    country_name,
    city_name,
    state_name,
  } = locationData;

  const payload = {
    ats_office: {
      name,
      location: locationData?.location || '',
      latitude: latitude,
      longitude: longitude,
      country_name: country_name,
      place_id: location_placeholder,
      city_name: city_name,
      state_name: state_name,
      hq,
      remote,
    },
  };

  // Only include ats_location_id if location data has NOT changed
  // If user changes location via map/select, don't send ats_location_id
  const hasLocationChanged =
    initialLocationData &&
    locationData &&
    Object.keys(locationData).length > 0 &&
    (String(initialLocationData.latitude) !== String(latitude) ||
      String(initialLocationData.longitude) !== String(longitude) ||
      String(initialLocationData.location_placeholder) !==
        String(location_placeholder));

  // Only send ats_location_id if no new location data is provided
  if (
    othersValues?.ats_location_id &&
    othersValues?.ats_location_id !== null &&
    !hasLocationChanged
  ) {
    payload.ats_office.ats_location_id = othersValues?.ats_location_id;
  }

  return payload;
};
